import { render, staticRenderFns } from "./GyomuHokokuK.vue?vue&type=template&id=42884dd3&scoped=true"
import script from "./GyomuHokokuK.vue?vue&type=script&lang=js"
export * from "./GyomuHokokuK.vue?vue&type=script&lang=js"
import style0 from "./GyomuHokokuK.vue?vue&type=style&index=0&id=42884dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42884dd3",
  null
  
)

export default component.exports